import { useQuery } from "@apollo/client";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import { GetCognitoUserQuery } from "../../graphql/queries/getUsers";

import { GET_USER } from "../../graphql/queries";
import { ROLES } from "../../constants";
import { addUserToGroup, removeUserFromGroup } from "./utils";
import {
  Button,
  CircularProgress,
  DialogActions,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";

interface Props {
  id?: string;
  open: boolean;
  handleClose: () => any;
  handleSubmit: () => any;
}

const ChangeRolesDialog: React.FC<Props> = ({ id, open, handleClose }) => {
  const {
    data: { getCognitoUser } = {},
    error,
    loading,
    refetch: reloadUser,
  } = useQuery<GetCognitoUserQuery>(GET_USER, {
    fetchPolicy: "cache-first",
    variables: { username: id },
    skip: !id,
    onError(error) {
      console.log(error);
    },
  });
  const { enqueueSnackbar } = useSnackbar();
  const { groups: roles = [] } = getCognitoUser || {};
  const [loadingRoles, setLoadingRoles] = React.useState<{
    [key: string]: boolean;
  }>(
    Object.keys(ROLES).reduce(
      (acc, key) => ({ ...acc, [ROLES[key].name]: false }),
      {}
    )
  );

  if (!id) {
    return null;
  }
  const _setLoading = (role: string) =>
    setLoadingRoles((current) => ({ ...current, [role]: !current[role] }));

  const _handleChangeRole = (role: string, removeFromRole: boolean) => {
    _setLoading(role);
    if (removeFromRole) {
      return removeUserFromGroup(id, role)
        .then(() => reloadUser())
        .then(() =>
          enqueueSnackbar(`${id} wurde aus der Gruppe ${role}  entfernt.`, {
            variant: "warning",
          })
        )
        .finally(() => _setLoading(role));
    } else {
      return addUserToGroup(id, role)
        .then(() => reloadUser())
        .then(() =>
          enqueueSnackbar(`${id} wurde der Gruppe ${role} hinzugefügt.`)
        )
        .finally(() => _setLoading(role));
    }
  };
  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      onClose={handleClose}
      aria-labelledby="create-user-dialog-title"
      PaperProps={{
        style: { width: 500 },
      }}
    >
      <DialogTitle id="create-user-dialog-title">
        {id} - Rolen bearbeiten
      </DialogTitle>
      <DialogContent style={{ padding: "20px" }}>
        <DialogContentText>Rollen für {id} bearbeiten</DialogContentText>
        {loading && <CircularProgress />}
        {!!error && <Typography> Fehler beim laden</Typography>}
        {!loading && !error && (
          <List>
            {Object.keys(ROLES).map((role) => {
              const { name } = ROLES[role];
              const hasRole = roles.includes(name);
              return (
                <ListItem key={role}>
                  <ListItemText primary={name} />
                  <ListItemSecondaryAction>
                    <Button
                      onClick={() => _handleChangeRole(name, hasRole)}
                      disabled={loadingRoles[name]}
                      variant={!hasRole ? "contained" : "text"}
                      color="secondary"
                    >
                      {hasRole ? "Entfernen" : "Hinzufügen"}
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeRolesDialog;
